import React from 'react';
import PropTypes from 'prop-types';
import SinglePicker from '../../common/controls/singlePicker';
const statuses = [{
  value: '1',
  id: '1',
  name: 'Active',
  label: 'Active'
}, {
  value: '0',
  id: '0',
  name: 'Inactive',
  label: 'Inactive'
}];
const StatusFilter = ({
  status,
  onFilter
}) => /*#__PURE__*/React.createElement(SinglePicker, {
  className: "t-esf-status",
  label: "Status",
  options: statuses,
  value: status,
  onChange: value => onFilter('status', value === null ? null : value.value)
});
StatusFilter.propTypes = {
  status: PropTypes.string.isRequired,
  onFilter: PropTypes.func.isRequired
};
export default StatusFilter;